import { render, staticRenderFns } from "./freeWrite.vue?vue&type=template&id=6574a2ce&scoped=true"
import script from "./freeWrite.vue?vue&type=script&lang=js"
export * from "./freeWrite.vue?vue&type=script&lang=js"
import style0 from "./freeWrite.vue?vue&type=style&index=0&id=6574a2ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6574a2ce",
  null
  
)

export default component.exports